import React from 'react';
import styled from 'styled-components';
import type { ProductInformationViewModel } from 'autogen/swagger/all';

const Wrapper = styled.div``;

export default function CompetitorMessage({
    competitorMessage
}: {
    competitorMessage: ProductInformationViewModel['competitorMessage'];
}): JSX.Element | null {
    if (!competitorMessage) return null;

    return <Wrapper dangerouslySetInnerHTML={{ __html: competitorMessage }} />;
}
